





























































import { Vue, Component } from 'vue-property-decorator';
import { Icon } from 'vant';
import VoteButton from '../components/VoteButton.vue';
import { getList } from '../api';
Vue.use(Icon);
@Component({
  components: {
    VoteButton,
  },
})
export default class Home extends Vue {
  tabs = [
    { text: '智能手机', id: 1 },
    { text: '电商消费', id: 3 },
    { text: '网络出行', id: 2 },
    { text: '百货卖场', id: 4 },
    { text: '家居卖场', id: 5 },
    { text: '家装公司', id: 6 },
    { text: '建材品牌', id: 7 },
  ];
  activeIndex = 0;

  dataList: any = [];
  get id() {
    return this.tabs[this.activeIndex].id;
  }
  created() {
    this.fetchData();
  }
  fetchData() {
    getList(this.id).then((res) => {
      this.dataList = res.data;
    });
  }
  updateZan(data: number, type: number) {
    if (type === 1) {
      this.dataList[data].votes++;
    } else if (type === 2) {
      this.dataList[data].dis_votes++;
    }
  }
  changeIndex(index: number) {
    this.dataList = [];
    this.activeIndex = index;
    this.fetchData();
  }
}
